import { Controller } from "@hotwired/stimulus"

// Low-frequency polling fallback for the face-switch batch status page.
//
// Turbo Streams over ActionCable remain the primary delivery mechanism for
// status updates; this controller only reloads the batch turbo-frame while
// the batch is still in a non-terminal state, so clients without a working
// WebSocket connection still see results. Polls are jittered, backed off
// after the first couple of minutes, capped, and skipped for hidden tabs.
// Polling stops as soon as the rendered frame reports a terminal state
// (data-batch-terminal="true").
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 5000 },
    maxPolls: { type: Number, default: 60 },
    backoffAfter: { type: Number, default: 24 },
    backoffFactor: { type: Number, default: 3 }
  }

  connect() {
    this.polls = 0
    this.schedule()
  }

  disconnect() {
    this.cancel()
  }

  schedule() {
    if (!this.shouldPoll()) return

    const base = this.polls >= this.backoffAfterValue
      ? this.intervalValue * this.backoffFactorValue
      : this.intervalValue
    const jitter = base * 0.2 * Math.random()
    this.timeout = setTimeout(() => this.poll(), base + jitter)
  }

  cancel() {
    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = null
  }

  poll() {
    this.polls += 1

    if (document.visibilityState !== "hidden") this.reloadFrame()

    this.schedule()
  }

  reloadFrame() {
    const frame = this.element.querySelector("turbo-frame")
    if (!frame) return

    if (frame.src) {
      frame.reload()
    } else {
      frame.src = window.location.href
    }
  }

  shouldPoll() {
    if (this.polls >= this.maxPollsValue) return false

    const state = this.element.querySelector("[data-batch-terminal]")
    return state ? state.dataset.batchTerminal !== "true" : false
  }
}
